import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from '@/app/routes/ProtectedRoute';
import { OwnerOnlyRoute } from '@/app/routes/OwnerOnlyRoute';
import {
  NotFoundPage,
  AuthLayout,
  DashboardLayout,
  LoginPage,
  DashboardPage,
  AllDownlineListing,
  Settlement,
  SubUsers,
  UserAccountStatement,
  AccountDetails,
  AccountSummary,
  UserBetHistory,
  UserBettingPL,
  TransactionHistory,
  ActivityLog,
  ContentManagement,
  BannerManagement,
  NotificationManagement,
  SupportContactManagement,
  AccountStatementPage,
  ActivityLogsPage,
  EventManagement,
  SettingsPage,
  BetList,
  PlDownline,
  PlByPlayer,
  PlByEvent,
  BusinessReports,
  ExportHistoryPage,
  BetSetting,
  Risk,
  SelfDepositPage,
  ChangeTransactionCodePage,
} from '@/app/routes';

export function App() {
  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route path="/" element={<DashboardPage />} />
          {/* Downline Routes */}
          <Route path="/members/:id" element={<AllDownlineListing />} />
          <Route element={<OwnerOnlyRoute />}>
            <Route path="/settlement" element={<Settlement />} />
          </Route>
          <Route path="/members/:id/:user/:memberid/:upline" element={<SubUsers />} />
          <Route path="/members/:id/sub/:memberid" element={<AccountDetails />}>
            <Route index element={<AccountSummary />} />
            <Route path="account-summary" element={<AccountSummary />} />
            <Route path="account-statement" element={<UserAccountStatement />} />
            <Route path="bet-history" element={<UserBetHistory />} />
            <Route path="betting-pl" element={<UserBettingPL />} />

            <Route path="transaction-history" element={<TransactionHistory />} />
            <Route path="login-history" element={<ActivityLog />} />
          </Route>
          {/* Risk Management Routes */}
          <Route path="/risk" element={<Risk />} />
          {/* Reports Routes */}
          <Route path="/bet-list" element={<BetList />} />
          <Route path="/pl-by-downline" element={<PlDownline />} />
          <Route path="/pl-by-player" element={<PlByPlayer />} />
          <Route path="/pl-by-event" element={<PlByEvent />} />
          <Route path="/business-reports" element={<BusinessReports />} />
          {/* change password */}
          <Route path="/settings" element={<SettingsPage />} />
          {/* Event Management*/}
          <Route element={<OwnerOnlyRoute />}>
            <Route path="/event-management/:status?" element={<EventManagement />} />
            <Route path="/bet-setting" element={<BetSetting />} />
          </Route>
          {/* Content Management */}
          <Route element={<OwnerOnlyRoute />}>
            <Route path="/content-management" element={<ContentManagement />}>
              <Route index element={<BannerManagement />} />
              <Route path="Notification" element={<NotificationManagement />} />
              <Route path="Contact" element={<SupportContactManagement />} />
            </Route>
          </Route>
          {/* Activity Logs */}
          <Route path="/activity-logs" element={<ActivityLogsPage />} />
          {/* Account statement */}
          <Route path="/account-statement" element={<AccountStatementPage />} />
          {/* Export History */}
          <Route path="/export" element={<ExportHistoryPage />} />
          <Route element={<OwnerOnlyRoute />}>
            {/* Self Deposit (Super Admin only) */}
            <Route path="/self-deposit" element={<SelfDepositPage />} />
            {/* change transaction code */}
            <Route path="/change-transaction-code" element={<ChangeTransactionCodePage />} />
          </Route>
        </Route>
      </Route>
      {/* </Route> */}

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
